const COMMON_PASSWORDS = [
	"password",
	"password123",
	"12345678",
	"123456789",
	"1234567890",
	"qwerty123",
	"abc123",
	"admin123",
	"welcome123",
	"letmein",
	"monkey",
	"dragon",
	"master",
	"sunshine",
	"princess",
	"football",
	"baseball",
	"iloveyou",
	"trustno1",
	"superman",
];

const SEQUENTIAL_PATTERNS = [
	/(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)/i,
	/(012|123|234|345|456|567|678|789|890)/,
	/(zyx|yxw|xwv|wvu|vut|uts|tsr|srq|rqp|qpo|pon|onm|nml|mlk|lkj|kji|jih|ihg|hgf|gfe|fed|edc|dcb|cba)/i,
	/(987|876|765|654|543|432|321|210)/,
];

const KEYBOARD_PATTERNS = [
	/qwerty/i,
	/asdf/i,
	/zxcv/i,
	/qaz/i,
	/wsx/i,
	/edc/i,
	/rfv/i,
	/tgb/i,
	/yhn/i,
	/ujm/i,
];

export function validatePassword(password: string, email?: string): string | null {
	if (password.length < 8) return "auth.pwErrMinLength";
	if (password.length > 128) return "auth.pwErrMaxLength";

	const typeCount = [/[A-Z]/, /[a-z]/, /[0-9]/, /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/].filter((r) =>
		r.test(password),
	).length;
	if (typeCount < 3) return "auth.pwErrTypeCount";

	for (const pattern of SEQUENTIAL_PATTERNS) {
		if (pattern.test(password)) return "auth.pwErrSequential";
	}

	if (/(.)\1{2,}/.test(password)) return "auth.pwErrRepeated";

	if (email) {
		const emailLocal = email.split("@")[0]?.toLowerCase() || "";
		if (emailLocal.length >= 3 && password.toLowerCase().includes(emailLocal))
			return "auth.pwErrContainsEmail";
	}

	const passwordLower = password.toLowerCase();
	for (const common of COMMON_PASSWORDS) {
		if (passwordLower === common || passwordLower.includes(common)) return "auth.pwErrCommon";
	}

	for (const pattern of KEYBOARD_PATTERNS) {
		if (pattern.test(password)) return "auth.pwErrKeyboard";
	}

	return null;
}
